import { notifications } from "@mantine/notifications"
import { parseAxiosError } from "@tfg/ui"
import i18next from "i18next"

type Props = {
  error: Error
  defaultMessage?: string
  showNotification?: boolean
  notificationTitle?: string
  notificationMessage?: string
}

export const showAxiosError = ({
  error,
  defaultMessage,
  showNotification = false,
  notificationTitle,
  notificationMessage,
}: Props) => {
  const axiosErrorMessage = parseAxiosError(error)
  let errorMessage = defaultMessage ?? i18next.t("error.default")
  if (axiosErrorMessage) {
    errorMessage = axiosErrorMessage
  }
  if (notificationMessage) {
    errorMessage = notificationMessage + errorMessage
  }
  if (notificationMessage) {
    errorMessage = notificationMessage + errorMessage
  }
  if (showNotification) {
    notifications.show({
      title: notificationTitle,
      message: errorMessage,
      color: "red",
    })
  }
  return error.message
}
